/*
 * © 2020 Microsoft. All rights reserved.
 */

define('Solitaire/GameState',['util/eventhandler',
		'Solitaire/ChallengeMode',
		'Solitaire/GameResult',
		'SolitaireShared/CardLogic/IGameAuthority',
		'SolitaireShared/KlondikeLogic/IDailyKlondikeAuthority',
		'Managers/TelemetryManager',
		'MenuUI/GameEndDialog', 'MenuUI/DealWarningModal', 'absolute'],
	function (EventHandler, ChallengeMode, GameResult, IGameAuthority, IDailyKlondikeAuthority,
	          TelemetryManager, GameEndDialog, DealWarningModal, Absolute) {
		var GameState = function (name, onEnter, onUpate, onLeave) {
			this.initGameState(name, onEnter, onUpate, onLeave);
		};

		GameState.prototype.initGameState = function (name, onEnter, onUpdate, onLeave) {

			this.OnEnter = new EventHandler();
			this.OnUpdate = new EventHandler();
			this.OnLeave = new EventHandler();

			this._name = name;
			this.OnEnter.add(onEnter);
			this.OnUpdate.add(onUpdate);
			this.OnLeave.add(onLeave);
		};

		GameState.prototype.ToString = function () {
			return "GameState:" + this._name;
		};

		GameState.ShowGameEndDialog = function (isWin, model) {
			var gameEndDialog = null;
			if (!GameState.CurrentGame.Authority.IsChallenge) {

				gameEndDialog = new GameEndDialog(GameState.CurrentGame.Parent.ui, GameState.CurrentGame.Parent.game, {
					challenge: GameState.CurrentGame.CurrentChallenge,
					dialog: isWin ? 'WinDialog' : 'GameOverDialog'
				});
				gameEndDialog.updateStats(model);
			}
			else {
				gameEndDialog = new GameEndDialog(GameState.CurrentGame.Parent.ui, GameState.CurrentGame.Parent.game, {
					challenge: GameState.CurrentGame.CurrentChallenge,
					dialog: isWin ? 'ChallengeWinDialog' : 'ChallengeGameOverDialog'
				});
				gameEndDialog.updateStats();
			}
			gameEndDialog.open();
		};

		GameState.CurrentGame = null;

		GameState._current = null;
		Object.defineProperty(GameState, "Current",
			{
				get: function () {
					return this._current;
				},
				set: function (value) {
					if (this._current == value) {
						return;
					}
					if (this._current != null && this._current.OnLeave != null) this._current.OnLeave.handleEvent();
					this._current = value;
					if (this._current != null && this._current.OnEnter != null) this._current.OnEnter.handleEvent();
				}
			});

		// Tell the current state to update!
		GameState.UpdateCurrent = function () {
			if (GameState.Current != null && GameState.Current.OnUpdate != null)
				GameState.Current.OnUpdate.handleEvent();
		};

		/// <summary>
		/// When the game is on screen, but the user has not performed a move yet.
		/// </summary>
		GameState.BeforeGame = new GameState(
			"BeforeGame",
			null,
			function () {
				if (GameState.CurrentGame.Authority.CardSupply.HasMovedCards) {
					GameState.Current = GameState.InProgress;
					// TODO AnalyticsHelper.Current.SendLevelStart();
					if (GameState.CurrentGame.CurrentChallengeMode == ChallengeMode.DailyChallenge) {
						// TODO is the XBox live? SolitaireAchievements.Instance.AwardAchievement(SolitaireAchievements.SolitaireAchievement.CameToPlay);
					}
				}
			},
			null
		);


		/// <summary>
		/// When the game is in progress.
		/// </summary>
		GameState.InProgress = new GameState("InProgress",
			function () {
				// on enter, make sure that the game is ready for a game to be played
				// turn on input, timer, etc.
				// currently there's not much to do here, but probably some stuff subscribes to this event.

				// On starting a game, see if it's the 5th game type we have started, meaning we have started every game type!

				// if this is a challenge, mark it as played
				if (GameState.CurrentGame.Authority.IsChallenge) {
					GameState.CurrentGame.CurrentChallenge.Played = true;
				}
			},
			function () {
				// on update, do this:


				if (GameState.CurrentGame.Authority.IsChallenge &&
					GameState.CurrentGame.Authority instanceof IDailyKlondikeAuthority &&
					(GameState.CurrentGame.Authority.GetCurrentMoveState() == IGameAuthority.MoveState.NoMovesLeft ||
						GameState.CurrentGame.Authority)) {
					//GameState.CurrentGame.Template.StopAutoSolving();
				}

				if (GameState.CurrentGame.Authority.IsGameWon()) {
					GameState.CurrentGame.GameResult = GameResult.Win;
					GameState.CurrentGame.Authority.OnGameOver(GameState.CurrentGame.SupplyView.CardSupply.GetActionList(), GameState.CurrentGame.SupplyView.CardSupply.GetCollapsedActionList());
					GameState.Current = GameState.GameComplete;
					setTimeout(function () {
						if (!GameState.CurrentGame.Authority.IsChallenge) {
							GameState.CurrentGame.DeleteSavedGame()
						}
					}, 0);
				}
				else if (GameState.CurrentGame.Authority.CurrentMoveState() == IGameAuthority.MoveState.NoMovesLeft &&
					GameState.CurrentGame.Authority.CardSupply.EnforceGameRules) {
					if (GameState.CurrentGame.Authority.IsChallenge ||
						(!GameState.CurrentGame.Authority.IsChallenge && !GameState.CurrentGame.Authority.CardSupply.WaitingForAnimation)) {
						GameState.CurrentGame.GameResult = GameResult.NoMoreMoves;
						GameState.Current = GameState.GameComplete;
					}
				}

			},
			null);

		/// <summary>
		/// When the game has been completed, and the ending animation sequence is on screen.
		/// </summary>
		GameState.GameComplete = new GameState("GameComplete",
			function () { // on enter


				var model = {};

				if (!GameState.CurrentGame.Authority.IsChallenge) {
					GameState.CurrentGame.ActiveMode.UpdateStatistics(model);
				}

				if (GameState.CurrentGame.GameResult == GameResult.Win) {

					GameState.CurrentGame.SupplyView.ClearKeyboardHighlight();
					GameState.CurrentGame.SupplyView.NextWinAnimation = GameState.CurrentGame.NextWinAnimation;

					if (!GameState.CurrentGame.OnOfGameEndAnimations) {
						// This callback will be called by the Win Animation system once the end animation is done running.
						if (GameState.Current == GameState.GameComplete) {
							GameState.Current = GameState.AfterGame;
							GameState.WriteSolvableDeckLog();
						}
						GameState.CurrentGame.NextWinAnimation = GameState.CurrentGame.SupplyView.NextWinAnimation + 1;
						GameState.CurrentGame.SaveSettings();

						GameState.ShowGameEndDialog(true, model);
					}
					else {
						//RttHelper.DisableRtt();
						//RttHelper.UnregisterEvents();
						GameState.CurrentGame.Authority.CardSupply.CardAnimator.TriggerWinAnimation(function () {
							//RttHelper.RegisterEvents();
							//RttHelper.TryEnableRtt();
							// This callback will be called by the Win Animation system once the end animation is done running.
							if (GameState.Current == GameState.GameComplete) {
								GameState.Current = GameState.AfterGame;
								GameState.WriteSolvableDeckLog();
							}
							GameState.CurrentGame.NextWinAnimation = GameState.CurrentGame.SupplyView.NextWinAnimation + 1;
							GameState.CurrentGame.SaveSettings();

							GameState.ShowGameEndDialog(true, model);

						});
						//alert('Congratulations!');
					}
				} else if (GameState.CurrentGame.GameResult === GameResult.NoMoreMoves) {


					if (GameState.CurrentGame.Authority.IsChallenge) {
						GameState.ShowGameEndDialog(false, model);
						GameState.CurrentGame.SaveSettings();
					} else {
						var noMoresMovesModal = new DealWarningModal(GameState.CurrentGame.Parent.ui.currentScreen,
							'dialogs.noMoreMovesHeadline', 'dialogs.noMoreMovesContent',
							function () {
								TelemetryManager.classicGameComplete(
									'NoMoreMoves', GameState.CurrentGame.Authority.CardSupply.GameName,
									Math.floor(GameState.CurrentGame.Authority.CardSupply.PreciseTimePlayed),
									GameState.CurrentGame.ScoringOption, GameState.CurrentGame.DrawOption,
									GameState.CurrentGame.SuitsOption,
                                    GameState.CurrentGame.Authority.CardSupply.Options.DIFFICULTY
								);
								noMoresMovesModal.close();
								GameState.ShowGameEndDialog(false, model);
								GameState.CurrentGame.SaveSettings();
							}.bind(this),
							function () {
								GameState.CurrentGame.Parent.game.solitaire.Undo();
								noMoresMovesModal.close();
							}, 'buttons.undoLastMove'
						);
					}

					if (GameState.CurrentGame.Parent.game.gameScreenUI.htp) {
						GameState.CurrentGame.Parent.game.gameScreenUI.closeFUE();
					}

				} else {
					GameState.ShowGameEndDialog(false, model);
				}
			},
			null,
			null);

		/// <summary>
		/// When the game is totally over, and the game end popup is on screen.
		/// </summary>
		GameState.AfterGame = new GameState("AfterGame",
			function () {
				// save the challenge completion state
				if (GameState.CurrentGame.GameResult == GameResult.Win) {
					if (GameState.CurrentGame.Authority.IsChallenge) {
						GameState.CurrentGame.CurrentChallenge.Completed = true;
					}
				}
				setTimeout(function () {
					if (!GameState.CurrentGame.Authority.IsChallenge) {
						GameState.CurrentGame.DeleteSavedGame()
					}
				}, 0);
				// TODO App.CurrentApp.SetInput(InputOption.Disable);
			},
			null,
			function () {
				// when we leave AfterGame, make sure the end animation is done
				if (GameState.CurrentGame.SupplyView && GameState.CurrentGame.SupplyView.CardSupply.CardAnimator.WinAnimator != null) {
					GameState.CurrentGame.SupplyView.CardSupply.CardAnimator.WinAnimator.EndAnimation();
				}
				// TODO App.CurrentApp.SetInput(InputOption.Enable);
			});

		GameState.WriteSolvableDeckLog = function () {
			//#if WRITE_SOLVABLE_DECKS
			if (!GameState.CurrentGame.Authority.IsChallenge) {
				// TODO?
				/*FileManager.Current.WriteTextFileAsync(
						"Game: " + GameState.CurrentGame.ActiveMode.Name + "\nSeed: " + GameState.CurrentGame.Authority.CardSupply.DeckSeed,
						GameState.CurrentGame.ActiveMode.Name + "SolvableDeck_" + DateTime.Now.ToString().Replace('/', '-').Replace(':', '.') + ".log",
					FileSource.StorageFiles);*/
			}
			//#endif
		};

		return GameState;
	});



